module.exports = __webpack_public_path__ + "static/media/comment.6a6b2898.svg";